const FAT_ENERGY_KCAL_PER_GRAM = 9;
const PROTEIN_ENERGY_KCAL_PER_GRAM = 4;
const SUGARS_ENERGY_KCAL_PER_GRAM = 4;
const ALCOHOL_ENERGY_KCAL_PER_GRAM = 7;

export function calculateEnergyKcal({
  fatPct = 0,
  proteinPct = 0,
  sugarsPct = 0,
  alcoholPct = 0,
}: Partial<{
  fatPct: number;
  proteinPct: number;
  sugarsPct: number;
  alcoholPct: number;
}>) {
  return (
    fatPct * FAT_ENERGY_KCAL_PER_GRAM +
    proteinPct * PROTEIN_ENERGY_KCAL_PER_GRAM +
    sugarsPct * SUGARS_ENERGY_KCAL_PER_GRAM +
    alcoholPct * ALCOHOL_ENERGY_KCAL_PER_GRAM
  );
}
